import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { ref, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../../../firebase";
import { useNavigate } from "react-router-dom";

export default function PopularProjectsWidget() {
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "projects"));

        if (querySnapshot.empty) {
          console.warn("Firestore'da hiç proje bulunamadı");
          setProjects([]);
          return;
        }

        const sortedDocs = querySnapshot.docs
          .sort((a, b) => parseInt(b.id) - parseInt(a.id))
          .slice(0, 8);

        const projectList = await Promise.all(
          sortedDocs.map(async (doc) => {
            const data = doc.data();
            const imagePaths = data.image_urls || [];
            const defaultImage =
              "/images/HomePage/Popularprojets/folkartnova.jpg";

            let imageUrl = defaultImage;
            if (imagePaths.length > 0) {
              try {
                const imageRef = ref(storage, imagePaths[0]);
                imageUrl = await getDownloadURL(imageRef);
              } catch (e) {
                console.warn("Görsel çekilemedi, yedek kullanılacak:", e);
              }
            }

            return {
              id: doc.id,
              title: data.project_name || "Proje İsmi",
              description: data.project_description || "Açıklama bulunamadı",
              city: data.city || "Şehir bilinmiyor",
              district: data.district || "İlçe bilinmiyor",
              deliveryDate: data.delivery_date || "Teslim tarihi bilinmiyor",
              image: imageUrl,
            };
          })
        );

        setProjects(projectList);
      } catch (err) {
        console.error("Proje yükleme hatası:", err);
        setError(err.message || "Projeler yüklenirken bir hata oluştu");
      }
    };

    fetchProjects();
  }, []);

  const handleCardClick = (id, e) => {
    if (e.target.closest("button")) return;
    navigate(`/project/${id}`);
  };

  const handleButtonClick = (e, id) => {
    e.stopPropagation();
    navigate(`/project/${id}`);
  };

  if (error) {
    return (
      <div className="popular-error">
        <p>Hata: {error}</p>
        <button onClick={() => window.location.reload()}>Tekrar Dene</button>
      </div>
    );
  }

  if (projects.length === 0) {
    return (
      <div className="popular-empty">
        <p>Gösterilecek proje bulunamadı</p>
      </div>
    );
  }

  return (
    <div className="popular-container">
      <h2 className="popular-header">Öne Çıkan Projeler</h2>
      <div className="popular-grid">
        {projects.map((project) => (
          <div
            key={project.id}
            className="popular-card"
            onClick={(e) => handleCardClick(project.id, e)}
          >
            <div className="popular-image-container">
              <img
                src={project.image}
                alt={project.title}
                className="popular-image"
                onError={(e) => {
                  e.target.src =
                    "/images/HomePage/Popularprojets/folkartnova.jpg";
                  console.warn(`Yedek görsel kullanıldı: ${project.id}`);
                }}
              />
            </div>
            <div className="popular-content">
              <h3 className="popular-title">{project.title}</h3>
              <p className="popular-description">{project.description}</p>
              <div className="popular-meta">
                <div className="popular-meta-item">
                  📍 {project.city} / {project.district}
                </div>
                <div className="popular-meta-item">
                  📅 {project.deliveryDate}
                </div>
              </div>
              <button
                className="popular-button"
                onClick={(e) => handleButtonClick(e, project.id)}
              >
                Projeyi İncele
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* --- STYLES --- */}
      <style>{`
        .popular-container {
          padding: 60px 20px;
          background-color: #f9fafc;
          font-family: "Inter", sans-serif;
        }

        .popular-header {
          text-align: center;
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 40px;
          color: #1a1a1a;
        }

        .popular-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 25px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .popular-card {
          background-color: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
          cursor: pointer;
          display: flex;
          flex-direction: column;
        }

        .popular-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 18px rgba(0, 0, 0, 0.15);
        }

        .popular-image-container {
          height: 200px;
          background: #f5f5f5;
        }

        .popular-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .popular-content {
          padding: 18px 20px 24px;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .popular-title {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 10px;
          color: #333;
        }

        .popular-description {
          font-size: 0.9rem;
          color: #666;
          line-height: 1.5;
          margin-bottom: 15px;
          flex-grow: 1;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .popular-meta {
          margin-bottom: 16px;
        }

        .popular-meta-item {
          font-size: 0.85rem;
          color: #777;
          margin-bottom: 6px;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .popular-button {
          padding: 12px;
          background-color: #ffc107;
          color: #333;
          border: none;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s ease;
        }

        .popular-button:hover {
          background-color: #e0a800;
        }

        .popular-error,
        .popular-empty {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 60px 20px;
          text-align: center;
          font-size: 1rem;
          color: #555;
        }

        .popular-error button {
          margin-top: 15px;
          padding: 10px 20px;
          background-color: #ff5722;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        /* --- RESPONSIVE --- */
        @media (max-width: 768px) {
          .popular-header {
            font-size: 1.6rem;
          }

          .popular-content {
            padding: 16px;
          }

          .popular-title {
            font-size: 1rem;
          }

          .popular-description {
            font-size: 0.85rem;
          }

          .popular-meta-item {
            font-size: 0.8rem;
          }
        }

        @media (max-width: 480px) {
          .popular-header {
            font-size: 1.4rem;
            margin-bottom: 25px;
          }

          .popular-grid {
            gap: 20px;
          }

          .popular-card {
            border-radius: 10px;
          }

          .popular-button {
            padding: 10px;
            font-size: 0.9rem;
          }
        }
      `}</style>
    </div>
  );
}
